import React from 'react';
import { cn } from './cn';

const EmptyState = ({ icon: Icon, title, description, action, className }) => (
  <div
    className={cn(
      'flex flex-col items-center justify-center text-center py-14 px-6 rounded-card border border-dashed border-line',
      className
    )}
  >
    {Icon && (
      <div className="w-12 h-12 rounded-2xl bg-accent-soft text-accent flex items-center justify-center mb-3">
        <Icon className="w-6 h-6" />
      </div>
    )}
    {title && <h3 className="text-base font-semibold text-primary">{title}</h3>}
    {description && <p className="mt-1 text-sm text-secondary max-w-sm">{description}</p>}
    {action && <div className="mt-4">{action}</div>}
  </div>
);

export default EmptyState;
